import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import ProfileCard from "candidate/Profile/ProfileCard";
import { PROFILE_STRENGTH, PROFILE_STRENGTH_TEXT } from "lib/constants";

const mapStateToProps = (state) => ({
    loading: state.ws.ui.loading,
    profileStrength: state.profile ? state.profile.completeness.strength : PROFILE_STRENGTH.OK,
});

const ApplicationSummaryProfileCard = ({ profileStrength }) => {
    const strength = PROFILE_STRENGTH_TEXT[profileStrength];

    return (
        <div className="app-summary__section">
            <div className="tooltip__parent">
                <div className="tooltip__container tooltip__container--top app-summary__profile-card-tooltip">
                    <header>Your profile right now is</header>
                    <p>{strength}</p>
                    <footer>
                        Take 5 minutes to make it <strong>Excellent</strong>
                    </footer>

                    <a href="/profile" className="btn btn-primary app-summary__profile-btn">
                        Improve your profile
                    </a>
                </div>
            </div>
            <ProfileCard className="app-summary__profile-card" />
        </div>
    );
};

ApplicationSummaryProfileCard.propTypes = {
    profileStrength: PropTypes.number.isRequired,
};

export default connect(mapStateToProps)(ApplicationSummaryProfileCard);
